import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconHdmi24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="HDMI">
            <path
                d="M5 13H19V11H5V13Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 7C0.447715 7 0 7.44772 0 8V15C0 15.4089 0.248951 15.7766 0.628609 15.9285L5.62861 17.9285C5.74673 17.9757 5.87278 18 6 18H18C18.1272 18 18.2533 17.9757 18.3714 17.9285L23.3714 15.9285C23.751 15.7766 24 15.4089 24 15V8C24 7.44772 23.5523 7 23 7H1ZM2 14.323V9H22V14.323L17.8074 16H6.19258L2 14.323Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
